import { EventCard as EventCardType } from "@/lib/producerTypes";
import { ProducerEventCard } from "./ProducerEventCard";

interface EventGridProps {
  items: EventCardType[];
}

export const EventGrid = ({ items }: EventGridProps) => {
  if (items.length === 0) return null;

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
      {items.map((event) => (
        <ProducerEventCard key={event.id} event={event} />
      ))}
    </div>
  );
};